import { Col, Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../../common/integrations'
import { useCallback, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { MappingType } from '../../../../../../../models/Account'
import { useGetIntegrationAdminSettings } from '../../../hooks'
import { SelectDocumentTypeSection } from './SelectDocumentTypeSection'
import { CustomDocumentAdminSettings } from './CustomDocumentAdminSettings'
import { DocumentSummaryMappingTester } from '../../../../TesterTool/DocumentSummary/DocumentSummaryMappingTester'
import { IntegrationMappingTesterAccordion } from '../../../../TesterTool/TesterAccordion'

export interface DocumentIntelligenceAdminSettingsProps {
  serviceId: IntegrationServiceId
}

export const DocumentIntelligenceAdminSettings: React.FC<DocumentIntelligenceAdminSettingsProps> = ({ serviceId }) => {
  const [formKey, setFormKey] = useState<number>(0)
  const { watch } = useFormContext<IntegrationSettings>()
  const currentMappingType = watch('mappings.documentSummary.mappingType')
  const isCustom = useMemo(() => currentMappingType === MappingType.CUSTOM, [currentMappingType])

  const refreshForm = useCallback(() => {
    setFormKey((prevKey) => prevKey + 1)
  }, [])

  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)

  if (isAccountFetching) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <Container className='py-3'>
      <Row className='mb-3'>
        <Col>
          <h3 className='mb-2'>Document Intelligence</h3>
          <div className='zocks-text-gray-600'>Configure where Zocks saves 'Document Intelligence' in {getIntegrationDisplayName(serviceId)}.</div>
        </Col>
      </Row>
      <Row>
        <SelectDocumentTypeSection onChange={refreshForm} serviceId={serviceId} />
      </Row>
      {isCustom ? (
        <>
          <Row>
            <CustomDocumentAdminSettings serviceId={serviceId} formKey={formKey} />
          </Row>
          <Row className='mt-5'>
            <IntegrationMappingTesterAccordion serviceId={serviceId} testerComponents={[DocumentSummaryMappingTester]} title='Test Document Export' />
          </Row>
        </>
      ) : null}
    </Container>
  )
}
